export const COURSE_CONTENT_SOURCE = {
  DOCUMENT: 'document',
  AI: 'ai',
} as const;

export type CourseContentSource =
  (typeof COURSE_CONTENT_SOURCE)[keyof typeof COURSE_CONTENT_SOURCE];
